export default {
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 查询操作类型
    queryOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/queryOperationType', params, response);
    },
    // 获取所有资源类型
    getAllResType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/getAllResType', params, response);
    },
    // 查询描述模板
    queryTemplate(params, response) {
        window.vue.$apiAxios.get('/template/getTemplateByType', params, response);
    },
    //查询日志设置
    queryLogSetting(params, response) {
        window.vue.$apiAxios.postRequestBody('/log/queryLogSetting', params, response);
    },
    //批量编辑日志设置
    batchUpdateLogSetting(params, response) {
        window.vue.$apiAxios.postRequestBody('/log/batchUpdateLogSetting', params, response);
    },
    //批量新增日志设置
    batchAddLogSetting(params, response) {
        window.vue.$apiAxios.postRequestBody('/log/batchAddLogSetting', params, response);
    }
};
